/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=0f70c1a4&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=0f70c1a4&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f70c1a4"]])

export default __exports__